<template>
    <!-- 规则引擎 -->
    <div class="box-main">
      <div class="main">
        <div>
          <div class="main-title">规则引擎</div>
        </div>
        <div class="main-center">
          <v-row class="tabs-demo__size">
        <v-col :span="22">
        <v-tabs v-model="activeName" size="S" name="tabs-s-card" type="card">
          <v-tab-pane label="解析器" value="1">
            <ParseList></ParseList>
          </v-tab-pane>
          <v-tab-pane label="数据源" value="2">
            <SourceList></SourceList>
          </v-tab-pane>
          <v-tab-pane label="数据目的" value="3">
            <PurposeList></PurposeList>
          </v-tab-pane>
        </v-tabs>
        </v-col>
      </v-row>
        </div>

      </div>

    </div>
</template>

  <script>
import ParseList from "@/components/rule-engine/parse/list-info.vue";
import SourceList from "@/components/rule-engine/data-source/list-info.vue";
import PurposeList from "@/components/rule-engine/data-purpose/list-info.vue";


export default {
  components: { ParseList, SourceList, PurposeList },
  data() {
    return {
      activeName:'1'
    };
  },
  created() {
    if(this.$route.query.id){
      this.activeName = this.$route.query.id
    }else{
      this.activeName = '1'
    }
  },
  methods: {

  },
  beforeDestroy() {},
};
</script>
<style lang="scss">

</style>
